/* -----------------Globals--------------- */
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import type { TextInput } from "react-native";

/* -----------------UI--------------- */
import { HelperText } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { useDevice } from "../../useDevice";
/* -----------------Child components--------------- */
import Box from "../Box";

import { isWeb } from "@memorang/helpers/platform";
import { useKeyboard } from "@react-native-community/hooks";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useAppTheme } from "../../useAppTheme";
import TextModeChatComposer from "../TextModeChatComposer";
/* -----------------Types--------------- */
import type { BottomAppBarProps } from "./types/props";

export const ChatBottomAppBar = forwardRef<TextInput, BottomAppBarProps>(
	(
		{
			interceptSearchQuery,
			searchPlaceholder,
			handleAbortSearch,
			searchContextMenu,
			disableSearch,
			isItemAnswered,
			showConversationMode = false,
			style,
		},
		_ref,
	) => {
		const { t } = useTranslation();
		const { isMobile, isMobileWeb } = useDevice();
		const { keyboardShown } = useKeyboard();
		const theme = useAppTheme();
		const insets = useSafeAreaInsets();

		const getPaddingBottom = () => {
			if (keyboardShown) {
				return 8;
			}
			if (isMobileWeb) {
				return 16;
			}

			return Math.max(insets.bottom, 8);
		};

		return (
			<Box
				width="100%"
				padding={16}
				backgroundColor={isWeb ? theme.colors.elevation.level1 : undefined}
				paddingBottom={getPaddingBottom()}
				{...style}
			>
				{showConversationMode && (
					<Box width={"100%"}>
						<TextModeChatComposer
							textInputProps={{
								placeholder: t("assistant.composer.placeholder", {
									assistantName: searchPlaceholder,
								}),
							}}
							isVoiceModeEnabled={false}
							onAbortResponse={handleAbortSearch}
							interceptResponseQuery={interceptSearchQuery}
							disableSearch={disableSearch}
							isItemAnswered={isItemAnswered}
						/>

						{searchContextMenu && !isMobile && (
							<HelperText style={{ textAlign: "center" }} type="info">
								{searchContextMenu}
							</HelperText>
						)}
					</Box>
				)}
			</Box>
		);
	},
);
